import { DEPARTMENTS, type Department } from '../../shared/contracts';
import { PANE_CATALOG } from '../../shared/pane-catalog';
import { useAuth, useHealth } from '../lib/queries';
import { greeting } from '../lib/greeting';
import { PaneGrid } from '../components/PaneGrid';
import { OverviewTop } from '../components/OverviewTop';
import { PeriodFilter } from '../components/PeriodFilter';
import { RefreshControl } from '../components/RefreshControl';
import { DemoBanner, ConnectorPills } from '../components/States';

const dateLabel = new Intl.DateTimeFormat('da-DK', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
}).format(new Date());

export function OverviewPage() {
  const { data: auth } = useAuth();
  const { data: health } = useHealth();
  const connectors = health?.connectors ?? [];

  const deptOrder = (d: Department) => DEPARTMENTS.indexOf(d);
  // admin.myAgenda + admin.board render together in OverviewTop (the agenda/board row), not the KPI grid.
  const kpiDescriptors = PANE_CATALOG.filter((p) => p.id !== 'admin.myAgenda' && p.id !== 'admin.board')
    .slice()
    .sort((a, b) => deptOrder(a.department) - deptOrder(b.department));

  return (
    <div>
      <div className="mb-6 border-b border-brand-primary/10 pb-6">
        <div className="mb-2 text-xs uppercase tracking-[0.18em] text-brand-primary/60">
          {dateLabel.charAt(0).toUpperCase() + dateLabel.slice(1)}
        </div>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <h1 className="font-heading text-3xl font-bold tracking-tight text-brand-primary sm:text-4xl">
            {greeting(auth?.user?.name)} 👋
          </h1>
          <div className="flex flex-col items-start gap-2 sm:items-end">
            <div className="flex flex-wrap items-center gap-2 sm:justify-end">
              <PeriodFilter />
              <RefreshControl />
            </div>
            {connectors.length > 0 && <ConnectorPills connectors={connectors} />}
          </div>
        </div>
      </div>

      {connectors.length > 0 && <DemoBanner connectors={connectors} />}
      <OverviewTop />
      <PaneGrid descriptors={kpiDescriptors} />
    </div>
  );
}
